import { styled } from 'styled-components'

import { Typography } from 'designSystem'

export const EditableTableIndexText = styled(Typography)`
  color: ${({ theme }) => theme.colors.accent[400]};
`
